export default __webpack_public_path__ + "static/media/bs.f4c0b453.svg";